import React from "react";
import "./Card.scss";
import githubIcon from "../../assets/icons/github.svg";
import linkedinIcon from "../../assets/icons/linkedin.svg";
import aviaInfoImg from "../../assets/images/aviaInfo.png";
import aviaInfoLogo from "../../assets/logos/aviainfo.jpg";
import planeIcon from "../../assets/icons/airplane.svg";
import securePayImg from "../../assets/images/securepay.jpg";
import securePayLogo from "../../assets/logos/mcsecure-pay.png";

export default function Card({ clickHandler }) {
  return (
    <>
      <div className="card">
        <h3 className="card__title">AviaInfo</h3>
        <img
          className="card__image"
          src={planeIcon}
          alt="Aviainfo screenshot"
        />
        <p className="card__description">
          A website provides licenses information and requirements for student
          pilots and pilots.
        </p>
        <button
          className="card__button"
          onClick={() =>
            clickHandler(
              "AviaInfo",
              "My final BrainStation project that I have to build within a 10 days timeframe. I wanted to create a website that can deliver beginner-friendly information, including progression updates without eliminating the critical details. Since government website contains highly technical and user-unfriendly information, oftentimes overwhelming newcomers and providing an extra level of training difficulties in their early stages. ",
              " MERN (MongoDB, Express.js, React.js, Node.js), SASS, Firebase, React-chat-bot",
              aviaInfoImg,
              true,
              "https://aviainfo.netlify.app/"
            )
          }
        >
          Click For More Details
        </button>
      </div>

      <div class="card">
        <h3 className="card__title">MasterCard SecurePay</h3>
        <img
          className="card__image card__masterCardLogo"
          src={securePayLogo}
          alt="Secure Pay screenshot"
        />
        <p className="card__description">
          A prototype app for MasterCard hackathon that provides secure payment.
        </p>
        <button
          className="card__button"
          onClick={() =>
            clickHandler(
              "MasterCard SecurePay",
              "Collaborated with a group of data scientists, UX/UI designers, and web developers to develop a prototype app that generates temporary credit card numbers and will be deleted once the transaction is completed.",
              " Express.js, React.js, Node.js, SASS, React-router",
              securePayImg,
              false,
              ""
            )
          }
        >
          Click For More Details
        </button>
      </div>
    </>
  );
}
